import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IResponseUpdatePassword, IRequestUpdatePasswordRecovery } from '@pacifico/interfaces/configurations-api';
import { ConfigurationsApiService } from '@pacifico/services/api/configurations/configurations-api.service';
import { PATHS_AUTH_PAGES } from '@pacifico/utils/path-page';
import { IResponse } from '@pacifico/services/api/endpoint-api';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
	requestUpdatePasswordRecovery!: IRequestUpdatePasswordRecovery;

	token = '';
	showSuccess = false;
	messageError = '';
	messageErrorCode = '';
	messageErrorPassword = '';
	messageErrorRepeatPassword = '';

	@Input() password = { partnerNumber: '', password: '', repeatPassword: '' };
	@ViewChild('changePasswordForm') cpForm!: NgForm;

	get regex(): boolean {
		return /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[&#.,;])[0-9a-zA-Z&#.,;]{8,}$/gm.test(this.cpForm?.controls.password?.value);
	}

	constructor(
		private route: ActivatedRoute,
		private _router: Router,
		private _configurationsApiService: ConfigurationsApiService
	) {}

	ngOnInit(): void {
		this.initialMessages();
		this.route.queryParams.subscribe((params) => {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
			this.token = params['token'];
			this.password.partnerNumber = this.token.substring(6);
			this.token = this.token.substring(0, 6);
		});
	}

	clickSave(): void {
		if (this.validateEqualPassword() && this.regex) {
			this._updatePassword(this.password.password, this.password.partnerNumber.padStart(7, '0'), this.token);
		}
	}

	goToLogin(): void {
		void this._router.navigateByUrl(PATHS_AUTH_PAGES.loginPage.withSlash);
	}

	private _updatePassword(password: string, partnerNumber: string, token: string): void {
		this.requestUpdatePasswordRecovery = {
			contrasenaNueva: password,
			operationCode: 'RECOVERY',
			userCode: partnerNumber,
			token: token.substring(0, 6)
		};

		this._configurationsApiService
			.updatePasswordRecovery(this.requestUpdatePasswordRecovery)
			.subscribe((res: IResponse<IResponseUpdatePassword>) => {
				if (res.status.code === '0000') {
					this.goToLogin();
				} else {
					this.cpForm.resetForm();
					this.messageError = res.status.message;
				}
			});
	}

	validatePartnerNumber(): boolean {
		return this.cpForm?.controls.partnerNumber?.touched && this.cpForm?.controls.partnerNumber?.invalid;
	}

	validatePassword(): boolean {
		return this.cpForm?.controls.password?.touched && !this.regex;
	}

	validateRepeatPassword(): boolean {
		return this.cpForm?.controls.repeatPassword?.touched && !this.validateEqualPassword();
	}

	initialMessages(): void {
		this.messageError = '';
		this.messageErrorCode = 'Coloque un código de socio válido';
		this.messageErrorPassword = 'Debe ingresar una contraseña válida';
		this.messageErrorRepeatPassword = 'Las contraseñas no coinciden';
	}

	validateEqualPassword(): boolean {
		return this.password.password.toUpperCase() === this.password.repeatPassword.toUpperCase();
	}
}
